export const validationPatterns = {
    "sortcode": "^[0-9]{2}[-][0-9]{2}[-][0-9]{2}$",
    "accountNumber": "^[0-9]{7,8}$",
    "rollNumber": "^[a-zA-Z0-9]{1,35}",
    "sortcodeSplit": /[^-]{2,2}/g
}   